const getHeightOfElement = element => element && element.offsetHeight;

export default getHeightOfElement;
